import React from 'react';
import { motion } from 'framer-motion';
import { TrendingUpIcon } from 'lucide-react';
export function Hero() {
  const scrollToReport = () => {
    const element = document.getElementById('deal-report');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-240">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-241">
        <img src="https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?q=80&w=2940&auto=format&fit=crop" alt="Luxury architecture" className="w-full h-full object-cover" data-id="element-242" />
        <div className="absolute inset-0 bg-gradient-to-b from-navy/95 via-navy/90 to-navy/95" data-id="element-243"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center pt-20" data-id="element-244">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-245">
          <div className="flex items-center justify-center mb-6" data-id="element-246">
            <TrendingUpIcon className="text-gold mr-3" size={32} data-id="element-247" />
            <span className="text-gold text-sm font-semibold tracking-wider uppercase" data-id="element-248">
              Institutional-Grade Deal Flow
            </span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-serif font-bold text-white mb-8 leading-tight" data-id="element-249">
            Curated Real Estate Deal Flow.
            <br data-id="element-250" />
            <span className="text-gold" data-id="element-251">Cabo San Lucas.</span>
          </h1>

          <p className="text-xl sm:text-2xl text-white/90 mb-12 max-w-4xl mx-auto leading-relaxed" data-id="element-252">
            Cabo Deal Flow is a curated, independently analyzed real estate
            investment resource. Every deal listed here has been vetted,
            researched, and backed by quantified data — rental yield, cash flow,
            ROI, equity upside. This is not a listing site.
            <span className="text-gold font-semibold" data-id="element-253"> This is deal flow.</span>
          </p>

          <motion.button onClick={scrollToReport} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="bg-gold hover:bg-gold-light text-navy px-10 py-4 rounded-lg font-bold text-lg transition-colors shadow-xl" data-id="element-254">
            Access the Deal Report
          </motion.button>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 1
    }} className="absolute bottom-8 left-1/2 transform -translate-x-1/2" data-id="element-255">
        <div className="w-6 h-10 border-2 border-white/30 rounded-full flex items-start justify-center p-2" data-id="element-256">
          <motion.div animate={{
          y: [0, 12, 0]
        }} transition={{
          duration: 1.5,
          repeat: Infinity
        }} className="w-1.5 h-1.5 bg-gold rounded-full" data-id="element-257" />
        </div>
      </motion.div>
    </section>;
}